



















import Vue from 'vue';
import Component from 'vue-class-component';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';
import { JumpToEventBusEvents, JumpToEventBus } from '@/webcomponents/header/components/JumpToEventBus';

const BrandhubIcon = () => import('../brandhub-icon/Icon.vue');
const LinkedinIcon = () => import('workbench-assets/dist/icons/linkedin.svg');

const SocialMediaBoxItemProps = Vue.extend({
  props: {
    iconName: String,
    linkUrl: String,
    linkTitle: String,
    editMode: Boolean,
    itemIndex: Number,
  },
});

@Component({
  components: {
    BrandhubIcon,
    LinkedinIcon,
  },
})
export default class SocialMediaBoxItem extends SocialMediaBoxItemProps {
  $refs!: {
    link: HTMLButtonElement;
  }

  get rootClasses () {
    return {
      'brandhub-social-media-box-item--edit-mode': this.editMode,
    };
  }

  onFocusIn () {
    this.$el.scrollIntoView({ block: 'center' });
  }

  onItemClick (): void {
    if (this.linkUrl) {
      const link = this.linkUrl;
      const label = this.linkTitle;
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Social Media Box', label, link);
    }
  }

  focusItem () {
    if (this.itemIndex === 0) {
      this.$refs.link.focus();
    }
  }

  created () {
    JumpToEventBus.$on(JumpToEventBusEvents.JumpToFooter, this.focusItem);
  }
}
